import request from "./../utils/request";

function searchDealsByPhone(phone) {
    return request({
        url: `/zoho/deals/search?phone=${phone}`,
        method: "get",
        params: {},
    }).then((res) => res.data);
}

function searchDealsByContactId(contactId) {
    return request({
        url: `/zoho/deals/search?contactId=${contactId}`,
        method: "get",
        params: {},
    }).then((res) => res.data);
}

function searchRecordsByPhone(module, phone) {
    return request({
        url: `/zoho/records/search?module=${module}&phone=${phone}`,
        method: "get",
        params: {},
    }).then((res) => res.data);
}
function searchRecordsByContactId(module, contactId) {
    return request({
        url: `/zoho/records/search?module=${module}&contactId=${contactId}`,
        method: "get",
        params: {},
    }).then((res) => res.data);
}

function getRecordById(module, id) {
    return request({
        url: `/zoho/records?module=${module}&id=${id}`,
        method: "get",
        params: {},
    }).then((res) => res.data);
}

function listTasks(module, id) {
    return request({
        url: `/zoho/records/tasks?module=${module}&id=${id}`,
        method: "get",
        params: {},
    }).then((res) => res.data);
}

function listDealNotes(dealId) {
    return request({
        url: `/zoho/deals/${dealId}/notes`,
        method: "get",
        params: {},
    }).then((res) => res.data);
}

function createDealNote(dealId, title, content, supsisUserId) {
    return request.post(`/zoho/deals/${dealId}/notes`, { title, content, supsisUserId }).then((res) => res.data);
}

function listAllUsers() {
    return request({
        url: `/zoho/users`,
        method: "get",
        params: {},
    }).then((res) => res.data);
}

function listModuleFields(module) {
    return request({
        url: `/zoho/fields?module=${module}`,
        method: "get",
    }).then((res) => res.data);
}
function listModules() {
    return request({
        url: `/zoho/modules`,
        method: "get",
    }).then((res) => res.data);
}

export const ZOHO_API = {
    searchDealsByPhone,
    searchDealsByContactId,
    listDealNotes,
    createDealNote,
    searchRecordsByPhone,
    searchRecordsByContactId,
    getRecordById,
    listAllUsers,
    listTasks,
    listModuleFields,
    listModules,
};
